import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";
import { Reveal } from "@/components/site/primitives";

const CHAPTERS = [
  { n: "01", t: "Academic Preparation", d: "Structured lessons that build depth and mastery across your chosen subjects." },
  { n: "02", t: "Discipline & Mentorship", d: "Guidance that shapes confidence, study habits and academic maturity." },
  { n: "03", t: "Examination Readiness", d: "Focused preparation for advanced-level examinations and what comes next." },
  { n: "04", t: "University Readiness", d: "A foundation designed for the academic demands of university education." },
];

export function Welcome() {
  return (
    <section className="relative py-20 sm:py-28" data-testid="welcome-section">
      <div className="container-x grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <span className="overline text-[#C0202A]">Welcome to the School of Basic Studies</span>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.08] text-[#0A1E4E]">
            A Stronger Foundation for Your University Journey
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            The School of Basic Studies provides structured academic preparation for students seeking alternative
            pathways toward university education — with a focus on quality teaching, mentorship and genuine
            university readiness.
          </p>
          <div className="mt-8 overflow-hidden rounded-sm border border-[#0A1E4E]/15 bg-[#0A1E4E] p-2">
            <motion.img
              src={IMAGES.collaborating}
              alt="IAUE School of Basic Studies admission flyer"
              className="w-full rounded-sm object-contain"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            />
          </div>
        </div>

        <div className="lg:col-span-7 lg:col-start-7">
          <div className="space-y-0 border-t border-slate-200">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.06}>
                <div className="group grid grid-cols-[auto,1fr] gap-6 border-b border-slate-200 py-8 transition-colors hover:bg-white">
                  <span className="font-mono text-sm font-semibold text-[#D4AF37] pt-1">{c.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-bold text-[#0A1E4E]">{c.t}</h3>
                    <p className="mt-2 text-slate-600 leading-relaxed">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
